import api from "@/services/api";

export default {
  getLogs(params) {
    return api
      .get("service-logs/", { params })
      .then((response) => response.data);
  },
  getUserUses(userId) {
    return api
      .get("service-logs/user-uses/", { params: { user: userId } })
      .then((response) => response.data);
  },
  updateUserUses(payload) {
    return api
      .post("service-logs/update-user-uses/", payload)
      .then((response) => response.data);
  },
  getNewUsers(params) {
    return api
      .get("service-logs/new-users/", { params })
      .then((response) => response.data);
  },
  // El Excel de marketing: seis hojas de conteos y una de ayuda, sin una sola
  // persona. Devuelve la respuesta entera y no solo `data` porque el nombre
  // del archivo lo pone el servidor en content-disposition.
  exportarMarketing(params) {
    return api.get("service-logs/exportar/", { params, responseType: "blob" });
  },
  grantUsesAll(payload) {
    return api
      .post("service-logs/grant-uses-all/", payload)
      .then((response) => response.data);
  },
};
